/* WAVE accepted payment badges, at the bottom of the slide-out cart and
   the cart page. 16 September 2026.

   Daniel asked for this after seeing a competitor show one.

   WHERE THE ICONS COME FROM. window.WAVE_PAY_ICONS, published by
   snippets/wave-payment-icons.liquid, which resolves each one through
   Shopify's payment_type_img_url filter. That matters. Shopify's payment
   icon filenames carry a content hash, for example visa-b614b878.svg, and
   that hash changes whenever Shopify updates the asset. Hardcoding the
   URLs here would break this row silently months from now.

   THE LIST IS DELIBERATELY SHORT, AND IT IS SHORT ON PURPOSE.
   Checked against the live checkout on 16 September 2026, WAVE accepts:
     Visa, Mastercard, Maestro, Apple Pay, Google Pay, Shop Pay,
     PayPal, Klarna.
   It does NOT accept American Express, Discover, Diners Club, JCB or
   UnionPay. The site footer may still show some of those; that is a
   separate thing to fix and is wrong. Never add a brand to this row that
   checkout will refuse. Showing a card logo the customer cannot actually
   pay with is worse than showing nothing, because they only find out
   after they have entered their details.

   To change what shows, edit the list in snippets/wave-payment-icons.liquid,
   not this file.

   TO REMOVE ENTIRELY: delete this file and its script tag in
   layout/theme.liquid. Nothing else depends on it. */
(function () {
  'use strict';

  if (window.WAVE_PAY_ROW_READY) { return; }
  window.WAVE_PAY_ROW_READY = true;

  var PAY_CLS = 'wave-pay-row';

  /* ---- PRODUCT PAGE, added 16 September 2026. --------------------------------
     Same row, same build(), same look, sitting directly under the Add to cart
     button on a product page.

     The class wave-pay-row-pdp is not cosmetic. sections/wave-product-messaging
     .liquid re-enforces the order of the buy block on every variant change and
     every DOM mutation, and it looks this exact class up by name. Rename it here
     and the row will be silently shoved out of place there. Change both or
     neither. */
  var PDP_CLS = 'wave-pay-row-pdp';

  /* Mirrors the guard in sections/wave-product-messaging.liquid: a floating
     add-to-cart bar is judged by computed position, not by class name, because
     the in-page form itself carries an "is--atc-sticky" flag and is NOT a
     floating bar. Without this the sticky bar's button box gets a row too. */
  function inFloatingBar(el) {
    var n = el;
    for (var i = 0; i < 6 && n && n !== document.body; i++) {
      if (getComputedStyle(n).position === 'fixed') { return true; }
      n = n.parentElement;
    }
    return false;
  }

  /* Prefer the theme's own resolver when wave-product-messaging has published
     it, so both files always agree on which button box is the real one. */
  function pdpBtnBox() {
    if (window.WAVEBuyArea && window.WAVEBuyArea.btnBox) {
      return window.WAVEBuyArea.btnBox();
    }
    var info = document.querySelector('.t4s-product__info-container');
    if (!info) { return null; }
    var all = info.querySelectorAll('.t4s-product-form__buttons');
    for (var k = 0; k < all.length; k++) {
      if (!inFloatingBar(all[k])) { return all[k]; }
    }
    return all[0] || null;
  }

  function pdpRow() { return document.querySelector('.' + PDP_CLS); }

  /* Idempotent on purpose. If a row is already on the page we leave it exactly
     where it is: wave-product-messaging.liquid owns its position and will move
     it back into the chain itself. Removing and rebuilding here would fight it. */
  function paintPdp() {
    if (!document.body || !document.body.classList.contains('template-product')) { return; }
    if (pdpRow()) { return; }
    var bb = pdpBtnBox();
    if (!bb || !bb.parentNode) { return; }
    var row = build();
    if (!row) { return; }
    row.className = PAY_CLS + ' ' + PDP_CLS;
    row.setAttribute('data-wave-scope', 'pdp');
    bb.insertAdjacentElement('afterend', row);
  }

  /* The same two containers assets/wave-cart-inject.js paints into:
       drawer    -> .t4s-minicart-group-btns        (sections/mini_cart.liquid)
       cart page -> .t4s-btn-group__checkout-update (sections/main-cart.liquid)
     Both were read from the theme. If neither is on the page we do nothing
     rather than inventing an insertion point. */
  var TARGETS = [
    { sel: '#t4s-mini_cart .t4s-minicart-group-btns', scope: 'drawer' },
    { sel: '.t4s-btn-group__checkout-update',         scope: 'cart' }
  ];

  function build() {
    var icons = window.WAVE_PAY_ICONS;
    if (!icons || !icons.length) { return null; }

    var row = document.createElement('div');
    row.className = PAY_CLS;
    row.setAttribute('aria-label', 'Accepted payment methods');
    row.style.cssText = 'display:flex;flex-wrap:wrap;justify-content:center;align-items:center;' +
                        'gap:5px 6px;margin:14px 0 2px;line-height:1;';

    var html = '';
    for (var i = 0; i < icons.length; i++) {
      var ic = icons[i];
      if (!ic || !ic.src) { continue; }
      html += '<img src="' + ic.src + '" alt="' + String(ic.name || '').replace(/"/g, '') + '" ' +
              'width="34" height="22" loading="lazy" decoding="async" ' +
              'style="display:block;width:34px;height:22px;object-fit:contain;">';
    }
    if (!html) { return null; }
    row.innerHTML = html;
    return row;
  }

  function paint(btns, scope) {
    if (!btns || !btns.parentNode) { return; }

    /* Same belt and braces as the rest of the cart code: clear the scoped
       one first, then any stray one left anywhere, so it cannot double up
       when the theme re-renders the drawer. */
    var old = btns.parentNode.querySelector('.' + PAY_CLS + '[data-wave-scope="' + scope + '"]');
    if (!old) { old = document.querySelector('.' + PAY_CLS + '[data-wave-scope="' + scope + '"]'); }
    if (old && old.parentNode) { old.parentNode.removeChild(old); }

    var row = build();
    if (!row) { return; }
    row.setAttribute('data-wave-scope', scope);
    btns.parentNode.insertBefore(row, btns.nextSibling);
  }

  /* ================================================================
     CART DRAWER UPSELL "ADD" BUTTON. 16 September 2026.

     THE PROBLEM. The "You may also like" carousel in the slide-out cart
     gave the shopper a quick view eye and nothing else. No way to add,
     so the upsell never converted.

     THE CARD, read from the live drawer, not guessed:
       .t4s-minicart-recommendations__item
         > .t4s-widget__pr
           > .t4s-widget_img_pr           a > img
           > .t4s-col.t4s-pr.t4s-oh       a.t4s-widget__pr-title, price
           > .t4s-col-auto               a.t4s-pr-item-btn.t4s-pr-quickview (the eye)

     TWO BEHAVIOURS, because most WAVE products cannot be one-click added.
     Tapes, wefts, nanobonds and clip-ins all carry length and colour, so
     the shopper must choose. Haircare, brushes and tools do not.

       exactly one purchasable variant -> POST /cart/add.js, quantity 1
       more than one                   -> open the theme's own quick view

     Quick view is opened by clicking the ORIGINAL eye link, which is left
     in the DOM and only hidden with an inline style. We never reimplement
     quick view, and if anything here fails the theme's own path still
     exists underneath.

     SOLD OUT is a real state, not an error: if the fetched product has no
     variant with available:true the button is shown disabled.
     ================================================================ */
  var UPSELL_CLS  = 'wave-upsell-add';
  var UPSELL_ITEM = '.t4s-minicart-recommendations__item';
  var UPSELL_QV   = 'a.t4s-pr-quickview';

  /* handle -> promise of the /products/<handle>.js payload. Cached so the
     carousel does not refetch every product each time the drawer repaints,
     and the drawer repaints on every cart change. */
  var prCache = {};

  function upsellHandle(href) {
    if (!href) { return ''; }
    var path = String(href).split('?')[0].split('#')[0];
    var bits = path.split('/products/');
    if (bits.length < 2) { return ''; }
    return bits[1].replace(/\/+$/, '').split('/')[0];
  }

  function fetchProduct(handle) {
    if (prCache[handle]) { return prCache[handle]; }
    prCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js',
                            { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return prCache[handle];
  }

  /* Dark pill, matching the Add to cart button's 31px radius. Styles are set
     inline, the same way every other row in this file is styled, so nothing
     here depends on a stylesheet the theme could rebuild. */
  function upsellBtnStyle(btn, off) {
    btn.style.cssText = 'display:inline-block;white-space:nowrap;border:0;' +
      'background:#222222;color:#ffffff;border-radius:31px;' +
      'font-family:inherit;font-size:11px;font-weight:600;line-height:1;' +
      'text-transform:uppercase;letter-spacing:0.04em;padding:7px 14px;' +
      'cursor:' + (off ? 'default' : 'pointer') + ';opacity:' + (off ? '0.55' : '1') + ';';
  }

  function setUpsellBtn(btn, text, off) {
    btn.textContent = text;
    btn.disabled = !!off;
    upsellBtnStyle(btn, !!off);
  }

  function openQuickView(btn) {
    var card = btn.closest ? btn.closest(UPSELL_ITEM) : null;
    var qv = card ? card.querySelector(UPSELL_QV) : null;
    if (qv) { qv.click(); }
  }

  /* Same event list assets/wave-cart-inject.js listens for, reused rather
     than reinvented. 'cart:update:count' is the one this theme fires itself
     and 'cart:refresh' is the hook third party code is told to fire, so
     between them the drawer re-renders its line items and subtotal. The
     /cart.js re-fetch mirrors that file's own rule: never trust a remembered
     total, always re-read. Repainting our own rows afterwards keeps the
     payment badges and the delivery message in step with the new basket. */
  function refreshCart() {
    for (var i = 0; i < CART_EVENTS.length; i++) {
      try {
        document.dispatchEvent(new CustomEvent(CART_EVENTS[i], { bubbles: true }));
      } catch (err) { /* a browser without CustomEvent still gets the fetch below */ }
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .catch(function () { /* the drawer is driven by the events above, not by this */ });
    setTimeout(paintAll, 400);
  }

  function upsellAdd(btn, variantId) {
    if (btn.getAttribute('data-wave-busy')) { return; }
    btn.setAttribute('data-wave-busy', '1');
    setUpsellBtn(btn, 'ADDING', true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
      .then(function () {
        setUpsellBtn(btn, 'ADDED', true);
        refreshCart();
        /* The drawer usually replaces this card before the timer fires, which
           is fine: the node is detached and the next paint builds a new one. */
        setTimeout(function () {
          btn.removeAttribute('data-wave-busy');
          setUpsellBtn(btn, 'ADD', false);
        }, 1400);
      })
      .catch(function () {
        /* Never leave the shopper stuck. Put the button back and hand them
           to the theme's own quick view, which can always complete the add. */
        btn.removeAttribute('data-wave-busy');
        setUpsellBtn(btn, 'ADD', false);
        openQuickView(btn);
      });
  }

  function onUpsellClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    var btn = ev.currentTarget;
    if (btn.disabled || btn.getAttribute('data-wave-soldout')) { return; }
    var vid = btn.getAttribute('data-wave-variant');
    if (vid) { upsellAdd(btn, vid); } else { openQuickView(btn); }
  }

  /* Idempotent: a card that already carries our button is left alone, so the
     observer below can call this as often as it likes. */
  function paintUpsellCard(card) {
    if (card.querySelector('.' + UPSELL_CLS)) { return; }
    var qv = card.querySelector(UPSELL_QV);
    if (!qv || !qv.parentNode) { return; }
    var handle = upsellHandle(qv.getAttribute('href'));
    if (!handle) { return; }

    /* Hidden, never removed. It is both the multi variant path and the
       fallback for every failure below. */
    qv.style.setProperty('display', 'none', 'important');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = UPSELL_CLS;
    btn.setAttribute('data-wave-handle', handle);
    btn.setAttribute('aria-label', 'Add to cart');
    setUpsellBtn(btn, 'ADD', false);
    btn.addEventListener('click', onUpsellClick);
    qv.parentNode.insertBefore(btn, qv);

    fetchProduct(handle).then(function (pr) {
      /* Card re-rendered while the fetch was in the air. Leave it: the next
         paint builds a fresh button against the fresh card. */
      if (!document.contains(btn)) { return; }
      /* No payload means we cannot tell single from multi, so leave the
         button on the quick view path rather than guess a variant. */
      if (!pr || !pr.variants || !pr.variants.length) { return; }

      var avail = [];
      for (var v = 0; v < pr.variants.length; v++) {
        if (pr.variants[v].available) { avail.push(pr.variants[v]); }
      }
      if (avail.length === 0) {
        btn.setAttribute('data-wave-soldout', '1');
        setUpsellBtn(btn, 'SOLD OUT', true);
        return;
      }
      if (avail.length === 1) {
        btn.setAttribute('data-wave-variant', String(avail[0].id));
      }
      /* More than one purchasable variant: no data-wave-variant, so the click
         handler opens quick view and the shopper picks length and colour. */
    });
  }

  function paintUpsell() {
    var cards = document.querySelectorAll(UPSELL_ITEM);
    for (var i = 0; i < cards.length; i++) { paintUpsellCard(cards[i]); }
  }

  function upsellMissing() {
    var cards = document.querySelectorAll(UPSELL_ITEM);
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector(UPSELL_QV) && !cards[i].querySelector('.' + UPSELL_CLS)) {
        return true;
      }
    }
    return false;
  }

  function paintAll() {
    for (var i = 0; i < TARGETS.length; i++) {
      var t = TARGETS[i];
      var btns = document.querySelector(t.sel);
      if (btns) { paint(btns, t.scope); }
    }
    paintPdp();
    paintUpsell();
  }

  function missing() {
    for (var i = 0; i < TARGETS.length; i++) {
      var t = TARGETS[i];
      var btns = document.querySelector(t.sel);
      if (btns && btns.parentNode &&
          !btns.parentNode.querySelector('.' + PAY_CLS + '[data-wave-scope="' + t.scope + '"]')) {
        return true;
      }
    }
    if (document.body && document.body.classList.contains('template-product') &&
        !pdpRow() && pdpBtnBox()) {
      return true;
    }
    if (upsellMissing()) { return true; }
    return false;
  }

  function boot() {
    setTimeout(paintAll, 350);
    /* The theme rebuilds the buy area well after first paint. Same retry points
       wave-product-messaging.liquid uses. */
    setTimeout(paintPdp, 1200);
    setTimeout(paintPdp, 2500);
    /* The recommendations carousel is fetched only when the drawer opens, so
       it is usually not there on first paint. The observer catches it; these
       are only a cheap head start. */
    setTimeout(paintUpsell, 1200);
    setTimeout(paintUpsell, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* 'cart:update:count' is the event this theme actually fires, confirmed
     15 Sep 2026. The rest are kept because other Shopify apps fire them and
     they cost nothing. */
  var CART_EVENTS = ['cart:update:count', 'cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'cart:build'];
  for (var e = 0; e < CART_EVENTS.length; e++) {
    document.addEventListener(CART_EVENTS[e], function () { setTimeout(paintAll, 400); });
  }

  /* The product page equivalent of CART_EVENTS. A variant change makes this
     theme swap the whole product form out, which takes the row with it. */
  var PDP_EVENTS = ['variant:changed', 'variantChange', 'wave:variant:changed'];
  for (var v = 0; v < PDP_EVENTS.length; v++) {
    document.addEventListener(PDP_EVENTS[v], function () { setTimeout(paintPdp, 200); });
  }

  /* Second line of defence. The theme replaces the drawer contents on every
     cart change and takes this row with it. Debounced so it cannot loop, and
     it only acts when the row is actually missing. */
  var pending = null;
  var observer = new MutationObserver(function () {
    if (!missing()) { return; }
    if (pending) { return; }
    pending = setTimeout(function () {
      pending = null;
      paintAll();
    }, 250);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
